import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: true,
    isPreview: false,
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        menuToggled(state) {
            state.open = !state.open;
            state.isPreview = false; // Clear preview when toggling
        },
        menuOpened(state) {
            state.open = true;
            state.isPreview = false;
        },
        menuClosed(state) {
            state.open = false;
            state.isPreview = false;
        },
        menuPreviewStarted(state) {
            if (!state.open) {
                state.isPreview = true;
            }
        },
        menuPreviewEnded(state) {
            state.isPreview = false;
        },
    },
});

export const { menuToggled, menuOpened, menuClosed, menuPreviewStarted, menuPreviewEnded } = menuSlice.actions;

export const selectors = {
    getMenuOpenState: state => state.menu.open,
    getMenuPreviewState: state => state.menu.isPreview,
    getMenuVisibleState: state => state.menu.open || state.menu.isPreview,
};

export default menuSlice.reducer;
